import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Chart from 'chart.js';
import { DateTimePickerField } from 'elements/form/fields';
import { MONTHS_SHORT } from "logic/constants";
import axios from 'axios';
import BreadcrumbHelper from 'logic/helpers/BreadcrumbHelper';
import DashboardModel from './model/DashboardModel';
import { Link } from 'react-router-dom';
import AppTable from '../../components/crud/AppTable';
import UserModel from '../users/all-users/models/UserModel';
import DeleteButton from '../../elements/list/DeleteButton';
import TransactionModel from '../cards/models/TransactionsModel';
import NumberHelper from '../../logic/helpers/NumberHelper';
import DateHelper from '../../logic/helpers/DateHelper';


export default class DashboardPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      totalProjects: 5,
      lastWeek: 10,
      lastMonth: 14,
      lastYear: 29,
      topSchools: [],
      data: [],
      schoolNames: [],
      labels: ["1", "2", "3", "4", "5", "6", "7"],
    }
  }

  componentDidMount() {
    this._loadData();

    Chart.defaults.global.defaultFontColor = 'white';
    this.renderOrderDotsChart();

    var color = Chart.helpers.color;

    var config = {
      type: 'pie',
      cutoutPercentage: 0,
      data: {

        datasets: [{
          data: [12, 19,],

          backgroundColor: [
            'rgba(124, 197, 118, 1)',
            'rgba(54, 162, 235, 1)'

          ],
          borderColor: [
            'rgba(89, 97, 107, 1)',
            'rgba(89, 97, 107, 1)'
          ],

          label: 'Dataset 1'
        }],
        labels: [
          "Orange",
          "Red"

        ]
      },

      options: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        legend: {
          fullWidth: true,
          display: true,
          labels: {
            fontColor: '#fff'
          }
        }
      }
    };


    var config2 = {
      type: 'doughnut',
      cutoutPercentage: 20,
      data: {

        datasets: [{
          data: [12, 19,],

          backgroundColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)'
          ],
          borderColor: [
            'rgba(89, 97, 107, 1)',
            'rgba(89, 97, 107, 1)'
          ],

          label: 'Dataset 1'
        }],
        labels: [
          "Red",
          "Orange"
        ]
      },

      options: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        legend: {
          fullWidth: true,
          display: true,
          labels: {
            fontColor: '#fff'
          }
        }
      }
    };

    var barChartConfig = {
      type: 'bar',
      data: {
        labels: ["8/2018", "9/2018", "10/2018", "11/2018", "12/2018", "1/2019"],
        datasets: [{
          label: '# of Votes',
          data: [400, 1000, 2500, 2300, 3000, 3250],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)'
          ],
          borderColor: [
            'rgba(255,99,132,1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        legend: {
          display: false,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    };




    var ctx3 = document.getElementById("barChartConfig").getContext("2d");
    window.barChartConfig = new Chart(ctx3, barChartConfig);
  }


  /**
   * Render customer chart
   */
  renderCustomerChart() {
    var ctx = document.getElementById("customerChart").getContext("2d");
    var customerChartData = {
      labels: this.getAllSchools(),
      datasets: [
        {
          label: "Total collected £",
          data: this.getAllSchoolsData(),
          backgroundColor: "rgba(54, 162, 235, 1)",
          hoverBackgroundColor: "#66A2EB"
        }]
    };

    var customerChart = new Chart(ctx, {
      type: 'horizontalBar',
      data: customerChartData,
      options: {
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            ticks: {
              beginAtZero: true
            }
          }],
          yAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            stacked: true
          }]
        }
      }
    });
  }

  renderOrderDotsChart() {
    var config = {
      type: 'line',
      data: {
        labels: MONTHS_SHORT,
        datasets: [{
          label: "Orders",
          data: [
            600,
            500,
            600,
            1000,
            1500,
            1200,
            1100,
            1250,
            1500,
            2000,
            1800,
            2000
          ],
          backgroundColor: 'rgba(54, 162, 235, 1)',
          borderColor: 'rgba(54, 162, 235, 0.4)',
          pointBorderColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 2,
          fill: false,
          showLine: true,
          borderDash: [2],
          pointRadius: 6,
          pointHoverRadius: 10
        }]
      },
      options: {
        responsive: true,
        legend: {
          display: false,
        },
        hover: {
          mode: 'index'
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'Month'
            }
          }],
          yAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            ticks: {
              max: 2200,
            },
            display: true,
            scaleLabel: {
              display: false,
            }
          }]
        }
      }
    };

    var ctx = document.getElementById("chart-dots").getContext("2d");
    window.myScatter = new Chart(ctx, config);

  }
  async _loadData(silent = false) {
    return;

    let projectsData = await (new DashboardModel()).getTotalProjects();
    let topSchools = await (new DashboardModel()).getTopSchools();
    try {
      this.setState({
        loading: false,
        lastWeek: projectsData.lastWeek,
        lastMonth: projectsData.lastMonth,
        lastYear: projectsData.lastYear,
        totalProjects: projectsData.totalProjects,
        topSchools: topSchools

      }, () => {
        this.renderCustomerChart();
      })
    } catch (e) {
      console.log(e);
    }
  }
  getAllSchools() {
    let topSchools = this.state.topSchools;

    let schoolList = [];
    topSchools.forEach((item, index) => {
      schoolList.push(
        item.name
      )
    })
    return schoolList;
  }
  getAllSchoolsData() {
    let topSchools = this.state.topSchools;

    let schoolData = [];
    topSchools.forEach((item, index) => {
      schoolData.push(
        item.value
      )
    })
    return schoolData;
  }
  render() {
    let schools = this.getAllSchools();
    return (
      <div className="dashboard-management">
        <h1><i className="fa fa-tachometer" aria-hidden="true"></i> Dashboard</h1>
        <div className="main-inner" style={{ paddingBottom: 20 }}>
          <div className="widget">
            <div className="dark-blur"></div>
            <div className="widget-header"><h3 className="widget-title"><i className="fa fa-users" aria-hidden="true"></i> TBD</h3></div>
            <div className="widget-inner">
              <div className="widget-new-customers" style={{display: 'none'}}>
                <i className="fa fa-bar-chart" aria-hidden="true"></i>
                <p className="customers-number">{this.state.totalProjects} <span>total users</span></p>
                <ul>
                  <li>Last week</li>
                  <li> {this.state.lastWeek}</li>
                </ul>
                <ul>
                  <li>Last month</li>
                  <li> {this.state.lastMonth}</li>
                </ul>
                <ul>
                  <li>Last year</li>
                  <li> {this.state.lastYear}</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="widget">
            <div className="dark-blur"></div>
            <div className="widget-header">
              <h3 className="widget-title">
                <i className="fa fa-bar-chart" aria-hidden="true"></i> TBD</h3>
            </div>
            <div className="widget-inner" style={{ padding: '10px' }}>
              <div style={{display: 'none'}}>
                <canvas id="chart-dots" style={{ width: '100%', height: '300px' }} width="600" height="300"></canvas>
              </div>
            </div>
          </div>
          <div className="widget">
            <div className="dark-blur"></div>
            <div className="widget-header">
              <h3 className="widget-title">
                <i className="fa fa-bar-chart" aria-hidden="true"></i> TBD
                </h3>
            </div>
            <div className="widget-inner" style={{ padding: '10px'}}>
              <div style={{ width: '100%', height: '100%', display: 'none'  }}>
                <canvas id="barChartConfig" style={{ width: '100%', height: '300px' }} width="600" height="300"></canvas>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div className="activated-cards">
              {/* <h1><i className="fa fa-bell" aria-hidden="true"></i> Add New Push Notifications</h1> */}
              <div className="dark-blur"></div>
              <div className="box-header">
                <h2><i className="fa fa-users"></i> Latest Users</h2>
                <div className="box-header-action">
                  <Link to="/users/all-users" className="button">List all</Link>
                </div>
              </div>
              <div className="box-body">
                <AppTable
                  title={null}
                  onInit={tableComponent => this._tableComponent = tableComponent}
                  // headerActions={<Link to="/users/all-users/add-new" className="button width-240" style={{ marginRight: '10px' }}><i className="fa fa-fw fa-plus"></i>Add new</Link>}
                  filter={[
                  ]}
                  order={[
                    {
                      field: 'id',
                      direction: 'desc'
                    }
                  ]}
                  paginate={false}
                  params={{
                    limit: 5,
                    offset: 0,
                    order: [
                      {
                        field: 'id',
                        direction: 'desc'
                      }]
                  }}
                  getTableColumns={() => {
                    return [
                      {
                        name: 'id',
                        label: 'Id',
                        sortable: false,
                        type: 'field'
                      },
                      {
                        name: 'firstName',
                        label: 'First Name',
                        sortable: false,
                        type: 'field'
                      },
                      {
                        name: 'lastName',
                        label: 'Last Name',
                        sortable: false,
                        type: 'field'
                      },
                      {
                        name: 'email',
                        label: 'E-mail',
                        sortable: false,
                        type: 'field'
                      },
                      {
                        name: null,
                        label: 'Actions',
                        sortable: false,
                        type: 'actions'
                      }
                    ]
                  }}
                  model={UserModel}
                  getColumnActions={(member, index) => {
                    return (
                      <div>
                        <Link to={`/users/all-users/details/${member.id}`} className="button-info">Details</Link>
                      </div>
                    )
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="activated-cards">
              {/* <h1><i className="fa fa-bell" aria-hidden="true"></i> Add New Push Notifications</h1> */}
              <div className="dark-blur"></div>
              <div className="box-header">
                <h2><i className="fa fa-users"></i> Latest Transactions</h2>
                <div className="box-header-action">
                  <Link to="/transaction" className="button">List all</Link>
                </div>
              </div>
              <div className="box-body">
              <AppTable
                  title={null}
                  onInit={tableComponent => this._tableComponent = tableComponent}
                  // headerActions={<Link to="/users/all-users/add-new" className="button width-240" style={{ marginRight: '10px' }}><i className="fa fa-fw fa-plus"></i>Add new</Link>}
                  filter={[
                  ]}
                  order={[
                    {
                      field: 'id',
                      direction: 'desc'
                    }
                  ]}
                  paginate={false}
                  params={{
                    limit: 5,
                    offset: 0,
                    order: [
                      {
                        field: 'id',
                        direction: 'desc'
                      }]
                  }}
                  renderCell={(column, item, index) => {
                    if (column.name === 'amount') {
                      return NumberHelper.currency(item.amount, item.amountCurrency)
                    }
                    if (column.name === 'transactionDate') {
                      return DateHelper.date(item.transactionDate, 'D / MMMM / Y')
                    }
                  }}
                  getTableColumns={() => {
                    return [
                      {
                        name: 'id',
                        label: 'Id',
                        sortable: false,
                        type: 'field'
                      },
                      {
                        name: 'note',
                        label: 'Note',
                        sortable: false,
                        type: 'field'
                      },
                      {
                        name: 'amount',
                        label: 'Amount',
                        sortable: false,
                        type: 'field'
                      },
                      {
                        name: 'transactionDate',
                        label: 'Tansaction Date',
                        sortable: false,
                        type: 'field'
                      },
                      {
                        name: null,
                        label: 'Actions',
                        sortable: false,
                        type: 'actions'
                      }
                    ]
                  }}
                  model={TransactionModel}
                  getColumnActions={(transaction, index) => {
                    return (
                      <div>
                        <Link to={`/users/transaction/details/${transaction.id}`} className="button-info">Details</Link>
                      </div>
                    )
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/DashboardPage.js